import { Skeleton } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { CONTROL_HEIGHT } from "../../../theme/tokens";

/** About as wide as "Origin: All ▾", so the row doesn't shift when the filter replaces it. */
const FILTER_WIDTH = "12ch";

/** Holds the Origin filter's place while the requests' origins load. */
export const RequestOriginFilterSkeleton: FC = () => {
	const { t } = useTranslation();
	return (
		<Skeleton
			variant="rounded"
			role="status"
			aria-label={t("request.origin.filter.loading")}
			data-testid="request-origin-filter-skeleton"
			sx={{ width: FILTER_WIDTH, height: CONTROL_HEIGHT.COMPACT, borderRadius: 1, flexShrink: 0 }}
		/>
	);
};
